export const CREATE_CASE_MESSAGE = "CREATE_CASE_MESSAGE";

export const REPLY_CASE_MESSAGE = "REPLY_CASE_MESSAGE";

export const GET_CASE_MESSAGES = "GET_CASE_MESSAGES";

export const GET_CASE_CONVERSATION_MESSAGES = "GET_CASE_CONVERSATION_MESSAGES";

export const COMPLETE_ACTIONABLE_TASK_SUCCESS = "COMPLETE_ACTIONABLE_TASK_SUCCESS";
